import {
  createRouter,
  createWebHistory
} from "vue-router";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: () => import(/* webpackChunkName: "about" */ "@/views/Page404View.vue")
  },
  /* {
    path: "/signIn",
    name: "SignIn",
    component: () => import(/!* webpackChunkName: "about" *!/ "@/views/AuthenticationView.vue")
  }, */
  {
    path: "/",
    name: "HomeView",
    component: () => import(/* webpackChunkName: "about" */ "@/views/HomeView.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 60 }
      };
    }
    return savedPosition || { x: 0, y: 0 };
  },
  routes
});

export default router;
